export default __webpack_public_path__ + "static/media/so.88916617.jpg";